import styled from 'styled-components';
import { media } from '../../styles/theme';

export const CabecalhoCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.xs} ${({ theme }) => theme.espaco.xl};
  padding: ${({ theme }) => theme.espaco.lg} ${({ theme }) => theme.espaco.xl};
  background-color: ${({ theme }) => theme.cores.card};
  border: 1px solid ${({ theme }) => theme.cores.border};
  border-radius: ${({ theme }) => theme.raio.card};
  color: ${({ theme }) => theme.cores.inkSecondary};

  .empresa {
    flex-basis: 100%;
    color: ${({ theme }) => theme.cores.ink};
    font-weight: 600;
  }

  ${media.mobile} {
    padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
    flex-direction: column;
  }

  @media print {
    border: none;
    padding: 0;
  }
`;

export const Secao = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.md};
`;

export const TituloBloco = styled.h3`
  font-size: ${({ theme }) => theme.fonte.h3};
  color: ${({ theme }) => theme.cores.ink};
`;

export const Bloco = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.espaco.sm};
`;

export const Rodape = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.espaco.sm} ${({ theme }) => theme.espaco.xl};
  padding: ${({ theme }) => theme.espaco.md} ${({ theme }) => theme.espaco.lg};
  background-color: ${({ theme }) => theme.cores.primary};
  border-radius: ${({ theme }) => theme.raio.card};
  color: ${({ theme }) => theme.cores.inkInverse};
  font-variant-numeric: tabular-nums;

  span {
    color: ${({ theme }) => theme.cores.inkInverseMuted};
    margin-right: ${({ theme }) => theme.espaco.xs};
  }

  strong {
    font-weight: 600;
  }
`;

export const TrSubTotal = styled.tr`
  td {
    background-color: ${({ theme }) => theme.cores.surface};
    font-weight: 600;
  }
`;
